import { compose, mdsWidget, mdsLazyProto } from 'dojo/_base/declare';
import { TranslationHelpers } from "../../../more/Helpers";
import _StatefulBase from '../_StatefulBase/_StatefulBase';

/**
 * Interface für das Widget das die Vererbungslinie angibt um die korrekten Typings zu setzen
 */
type _LabelInputBase__mdsbase = InstanceType<typeof _StatefulBase>;
interface _LabelInputBase extends  _LabelInputBase__mdsbase { }
export default function _LabelInputBase(__Base: any) {
  const __C = 
class _LabelInputBase extends __Base {

    protected _label: string;
    protected placeholder: string;
    labelNode: HTMLElement;
    _isLabelVisible: boolean;

    setLabel(newValue: string): void {
        newValue = TranslationHelpers.tryTranslate(newValue);

        this._label = newValue;
        this.setLabelVisibility(!!newValue);
        this.setLabelValue(newValue);
    }

    /**
     * Positioniert das Label an eine andere Stelle, zB. vor oder über das Input.
     * Je nach Widget können bestimmte Varianten verfügbar oder nicht verfügbar sein.
     * @param position
     */
    setLabelPosition(position: "front" | "default" | "top") {
        if (!position) return;
        if (this._setLabelPosition) {
            this._setLabelPosition(position);

            if (this.labelNode) {
                this.UiModder.domClass.remove(this.labelNode, "front default top");
                this.UiModder.domClass.add(this.labelNode, position)
            }
        }
    }

    private _setLabelPositionAttr(position) {
        this.setLabelPosition(position as any);
    }

    protected _setLabelPosition(position: "front" | "default" | "top") {
        // muss in Childwidgets ausgestaltet werden!
        if (this.labelNode) {
            switch (position) {
                case "default":
                default:
                case "top":
                    break;

                case "front":

                    break;
            }
        }
    }

    protected setLabelValue(newValue): void {
        // wird ggf in kindklasse ausprogrammiert

        if (this.labelNode) {
            this.UiModder.domAttr.set(this.labelNode, "innerHTML", this._label);
            //this.labelNode.textContent = this._label;
        }
    }

    protected setIsLabelVisibleStyle(): void {
        if (this.labelNode) {
            this.hideNode(this.labelNode, !this._isLabelVisible)
        }
    }

    getLabel(): string {
        return this._label;
    }

    removeLabel(): void {
        this._label = null;
        this.removeLabelNode();
    }

    protected removeLabelNode(): void {
        // 
        if (this.labelNode) this.hideNode(this.labelNode);
    }

    setLabelVisibility(visibility: boolean): void {
        visibility === false? this._isLabelVisible = false: this._isLabelVisible = true;
        this.setIsLabelVisibleStyle();
    }

    setPlaceholder(text: string): void {
        if (text && this.canTranslate(text)) text = this.translate(text);

        this.placeholder = text;
        this.setPlaceholderValue();
    }

    protected setPlaceholderValue(): void {
        // wird in kindklasse ausprogrammiert
    }
    // dojo-Setter und Getter

    _setPlaceholderAttr(text: string): void {
        this.setPlaceholder(text);
    }

    _getPlaceholderAttr(text: string): void {
        this.setPlaceholder(text);
    }

    _setLabelAttr(newValue: string): void {
        if (this.setLabel) {
            this.setLabel(newValue);
        }
    }

    _getLabelAttr(): void {
        if (this.getLabel) {
            this.getLabel();
        }
    }

    _setIsLabelVisibleAttr(visibility: boolean): void {
        this.setLabelVisibility(visibility);
    }

    postCreate(): void {
        let self: any = this;
        super.postCreate.apply(this, arguments as any);
    }

    public setAllDataCyAttributes() {
        const inputEl: HTMLElement = (this as any).inputNode;
        if (inputEl) this.setDataCyAttribute(inputEl, "");
    }

    startup(): void {
        // required for dojo inheritance to call the superclass
        let self: any = this;
        super.startup.apply(this, arguments as any);
    }

}

;
Object.assign(__C.prototype, {
  _label: "",
  placeholder: "",
  _isLabelVisible: false,
  declaredClass: '_LabelInputBase',
});
  return __C;
}
Object.assign(_LabelInputBase, { __mdsMixinFactory: true, __mdsSpineBases: [_StatefulBase] });